
import { FirearmEntityDecorator } from '../../firearm/model/firearm.decorator';
import { Firearm } from '../../firearm/model/firearm.model';
import { RangerEntityDecorator } from '../../ranger/model/ranger.decorator';
import { Ranger } from '../../ranger/model/ranger.model';
import { AssetsUserDetailsEntityDecorator } from '../../userdetails/model/assets-user-details.decorator';
import { AssetsUserDetails } from '../../userdetails/model/assets-user-details.model';
import { FIREARM_POOL_METADATA } from './firearm-pool.metadata';
import { FirearmPool } from './firearm-pool.model';
import { EntityDecorator, GenericEntityDecorator } from '@scisys-uim/uim-common';


export abstract class FirearmPoolEntityDecoratorBase extends GenericEntityDecorator<FirearmPool, number> {
  constructor() {
    super(FIREARM_POOL_METADATA, {
      get firearm(): EntityDecorator<Firearm, number> {
        return new FirearmEntityDecorator();
      },
      get manager(): EntityDecorator<AssetsUserDetails, string> {
        return new AssetsUserDetailsEntityDecorator();
      },
      get members(): EntityDecorator<Ranger, number> {
        return new RangerEntityDecorator();
      }
    }, {
    });
  }
  toKeyObjectFromRouteParams(params: any): number {
    if (params == null || params.firearmAssetId == null) {
      return null;
    }
    return parseInt(params.firearmAssetId);
  }
  toKeyUrlPathSegments(key: number): string {
    if (key == null) {
      return null;
    }
    return '' + key;
  }
  toKeyRouteSegments(item: FirearmPool): any[] {
    const key: number = this.metadata?.toKeyObject(item);
    if (key == null) {
      return null;
    }
    return [key];
  }
}




